import { makeStyles } from 'tss-react/mui';

const useStylesDeleteIconButton: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  deleteIconButton: {
    position: 'absolute',
    width: '15px !important',
    height: '15px !important',
    color: theme.palette.common.black,
    cursor: 'pointer',
  },
}));

export default useStylesDeleteIconButton;
